import queryString from 'query-string';
import { CHECKOUT_LAYOUT_PATHS } from 'base/config/checkout-layout-paths';
import site from 'pro/config/site';
import { getSearch } from 'ava-util/dist/request';

export function getLangInPath(path) {
    if (!path) {
        path = window.location.pathname;
    }
    let langInPath = '';
    if (path.search(/^\/[a-z][a-z]\//) === 0) {
        langInPath = path.substr(0, 4).replace(/\//g, '').toLowerCase()
    } else if (path.length === 3) {
        langInPath = path.substr(1, 2);
    }
    return langInPath || 'en';
}

export function getProjectInHost(host) {
    return host.replace(/.*?\.([a-zA-Z0-9][-a-zA-Z0-9]{0,62})\..*/, '$1');
}

export function getQueryInUrl(url) {
    if (url.indexOf('?') !== -1) {
        let str = url.replace(/^.*?\?/, '');
        if (url.indexOf('#') !== -1) {
            str = url.replace(/#.*/, '');
        }
        return queryString.parse(str, { arrayFormat: 'bracket' });
    }
    return {};
}

export function getNewLangPathname(pathname: string, newLang?: string) {
    const oldLang = getLangInPath(pathname);

    if (oldLang === newLang || !newLang) {
        return pathname;
    }
    if ([`/${oldLang}`, '/', ''].includes(pathname)) {
        return newLang === 'en' ? '/' : `/${newLang}`;
    }

    const langPrefx = newLang === 'en' ? '' : `/${newLang}`
    const withoutLang = pathname.replace(`/${oldLang}/`, '/');
    return langPrefx + withoutLang;
}

export function getPathnameWithoutLang(pathname) {
    if (pathname.length === 3) {
        return '/';
    }
    return pathname.replace(/^\/[a-z][a-z]\//, '/')
}

// 根据 url 判断页面 layout 类型
export const getPageLayout = (url: string): 'default' | 'checkout' => {
    const pathname = url.replace(/\?.*$/, '').replace(/#.*$/, '');
    return CHECKOUT_LAYOUT_PATHS.includes(pathname)
        ? 'checkout'
        : 'default';
}

export type IUtmQuery = {
    utm_source?: string;
    utm_content?: string;
    utm_medium?: string;
    utm_campaign?: string;
    utm_term?: string;
}

export function getUtmQuery(refid: string, params: IUtmQuery = {}): IUtmQuery {
    const obj = {
        ...params,
        utm_source: params.utm_source || 'unknown',
        utm_content: params.utm_content || 'common'
    } as IUtmQuery;

    if (refid) {
        obj.utm_medium = 'referral-n';
        obj.utm_campaign = refid;
    }

    return obj
}

export function getRelativeUrl(url: string): string {
    const search = getSearch(url);
    // 删除 orgion 和 query
    let pathname = url.replace(/\?.*$/, '');
    // 删除域名
    if (/^(http:|https:)*\/\//.test(pathname)) {
        pathname = pathname.replace(/^(http:|https:)*\/\//, '');
        if (!pathname.includes('/')) {
            pathname = '/';
        } else {
            pathname = pathname.replace(/.*?\//, '/');
        }
    }
    // 删除 locale
    pathname = pathname.replace(/^\/[a-zA-Z]{2}(-[a-zA-Z]{2}){0,1}$/, '/').replace(/^\/[a-zA-Z]{2}(-[a-zA-Z]{2}){0,1}\//, '/');
    return pathname + search;
}

export function getUrlLocale(url: string): string {
    url = url.replace(/\?.*$/, '').replace(/#.*$/, '');
    // /en
    if (/^\/[a-zA-Z]{2}(-[a-zA-Z]{2}){0,1}$/.test(url)) {
        return url.replace(/\//g, '');
    }

    const match = url.match(/^\/[a-zA-Z]{2}(-[a-zA-Z]{2}){0,1}\//);
    if (match) {
        return match[0].replace(/\//g, '');
    }
    return '';
}

export function transLocale(locale: string): { lang: string, country: string } {
    let lang = '';
    let country = '';
    if (locale) {
        if (locale.length === 2) {
            lang = locale
        } else if (locale.length === 5) {
            lang = locale.substring(0, 2);
            country = locale.substring(3, 5).toUpperCase();
        }
    }
    return {
        lang: lang.toLowerCase(),
        country: country.toUpperCase()
    }
}
